/**
 * Formats a phone number string to (XXX) XXX-XXXX format
 * Auto-formats as user types for better UX
 * @param value - Raw input string
 * @returns Formatted phone string
 */
export const formatPhoneNumber = (value: string): string => {
  // Remove all non-digit characters
  const digits = value.replace(/\D/g, '');

  // Limit to 10 digits
  const limited = digits.slice(0, 10);

  // Format progressively as user types
  if (limited.length === 0) return '';
  if (limited.length <= 3) return `(${limited}`;
  if (limited.length <= 6) return `(${limited.slice(0, 3)}) ${limited.slice(3)}`;
  return `(${limited.slice(0, 3)}) ${limited.slice(3, 6)}-${limited.slice(6)}`;
};

/**
 * Validates a phone number has exactly 10 digits
 * @param value - Phone string (formatted or raw)
 * @returns true if valid US phone number
 */
export const isValidPhoneNumber = (value: string): boolean => {
  const digits = value.replace(/\D/g, '');
  return digits.length === 10;
};
